import { buildHref } from "@softmax/web-addresses";
export const feedbackSessionStorageKey = "softmax.feedback.active-session";
const feedbackSessionChanged = "softmax:feedback-session-changed";

export function subscribeFeedbackSession(listener: () => void) {
  window.addEventListener("storage", listener);
  window.addEventListener(feedbackSessionChanged, listener);
  return () => {
    window.removeEventListener("storage", listener);
    window.removeEventListener(feedbackSessionChanged, listener);
  };
}

export function storageGet(key: string): string | null {
  try {
    return window.sessionStorage.getItem(key);
  } catch (error) {
    if (!(error instanceof DOMException)) throw error;

    return null;
  }
}

export function storageSet({
  key,
  value,
}: {
  readonly key: string;
  readonly value: string | null;
}) {
  try {
    if (value === null) {
      window.sessionStorage.removeItem(key);
    } else {
      window.sessionStorage.setItem(key, value);
    }

    window.dispatchEvent(new Event(feedbackSessionChanged));
  } catch (error) {
    if (!(error instanceof DOMException)) throw error;
  }
}

export function closeFeedback() {
  storageSet({ key: feedbackSessionStorageKey, value: null });
  window.location.assign(buildHref({ name: "admin.feedback" }));
}
